import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, Grid, IconButton, makeStyles, TextField, Typography } from '@material-ui/core';
import starWhiteIcon from 'src/theme/scss/icons/starWhite.svg';
import copyIcon from 'src/theme/scss/icons/copy.svg';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
    root: {
        color: '#FFFFFF',
        height: '48px',
        width: '48px',
        transition: 'transform .3s',
        "& img": {
            fill: '#25D366',
            height: '24px',
            width: '24px',
        }
    },
    content: {
        position: 'fixed',
        bottom: props => props.menuIsVisible ? '80px' : '8px',
        left: '8px',
        right: '8px',
        backgroundColor: '#333333',
        padding: '16px',
        borderRadius: '8px',
        opacity: '0',
        visibility: 'hidden',
        transition: 'all .3s',
        '&.show': {
            opacity: '1',
            visibility: 'visible',
        },
    },
    affiliateCopyButton: {
        marginLeft: '5px',
        padding: '12px 15px',
        '&:hover': {
            backgroundColor: '#2E1C70',
        }
    },
    affiliateTitle: {
        color: '#fff',
        fontSize: '24px',
        fontWeight: '700',
        lineHeight: '36px'
    },
    affiliateText: {
        color: '#fff',
        fontSize: '14px',
        lineHeight: '24px',
    }
}));

function BottomNavAffiliate({ menuIsVisible }) {
    const classes = useStyles({ menuIsVisible });
    const ref = useRef(null);
    const refCopyText = useRef(null);
    const [translate, i18n] = useTranslation();
    const [showAffiliateMenu, setShowAffiliateMenu] = useState(false);
    const [shareUrl, setShareUrl] = useState('');
    const [buttonCopy, setButtonCopy] = useState(false);
    const userAccount = useSelector(store => store.account.user);
    const affiliateId = useMemo(() => (userAccount && userAccount.affiliateGroup ? userAccount.id : ''), [userAccount]);

    const generataLink = () => {
        const url = new URL(window.location.href);
        url.searchParams.set('affiliateId', affiliateId);
        setShareUrl(url.href);
    };

    const handleClick = () => {
        generataLink();
        setShowAffiliateMenu(!showAffiliateMenu)
    };

    const copyText = () => {
        var copyText = refCopyText.current;
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand('copy');
        setButtonCopy(true);
    };

    useEffect(() => {
        if (ref.current) {
            if (showAffiliateMenu) {
                ref.current.classList.add('show');
            } else {
                ref.current.classList.remove('show');
            }
        }
    }, [showAffiliateMenu]);

    useEffect(() => {
        generataLink();
    }, [window.location.pathname]);

    if (!affiliateId) {
        return null;
    }

    return (
        <Box>
            <IconButton className={classes.root} onClick={handleClick}>
                <img loading="lazy" src={starWhiteIcon} alt="" />
            </IconButton>
            <Box ref={ref} className={classes.content}>
                <Box display="flex" justifyContent="space-between">
                    <Typography
                        variant="h4"
                        color="inherit"
                        className={classes.affiliateTitle}
                    >
                        {translate('textTitleAffiliate')}
                    </Typography>
                </Box>
                <Typography
                    variant="body1"
                    color="inherit"
                    className={classes.affiliateText}
                >
                    {translate('textTextAffiliate')}
                </Typography>
                <Grid container>
                    <Grid item xs={9}>
                        <TextField
                            margin="dense"
                            name="copyURL"
                            value={shareUrl}
                            variant="outlined"
                            fullWidth
                            inputRef={refCopyText}
                            sx={{
                                'input': {
                                    color: '#9B959F',
                                    fontSize: '14px',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <Box mr={2} mt={1}>
                            <Button
                                variant="outlined"
                                onClick={copyText}
                                className={classes.affiliateCopyButton}
                                style={{
                                    backgroundColor: buttonCopy ? '#008000' : '#2E1C70'
                                }}
                            >
                                <img loading="lazy" src={copyIcon} alt="" />
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}

export default BottomNavAffiliate;
